import { Helmet } from "react-helmet-async";

type SeoProps = {
  title: string;
  description: string;
  url: string;
};

export function Seo({ title, description, url }: SeoProps) {
  console.log("SEO mounted:", title);
  return (
    <Helmet>
      <html lang="ru" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
    </Helmet>
  );
}
